import './index.css'
import cn from 'clsx'

import React from 'react'
type Props = {
  color: string
  disabled?: boolean
  enabled?: boolean
  label: string
  onToggle: (...args: Array<any>) => any
}

/**
 * Chart toggle component for enabling/disabling chart data series
 * Displays a colored marker and label with interactive toggle functionality
 * @param color - Color for the toggle marker when enabled
 * @param disabled - Whether the toggle is disabled and non-interactive
 * @param enabled - Whether the toggle is currently enabled
 * @param label - Text label to display next to the toggle marker
 * @param onToggle - Callback function when toggle state changes
 */
const Toggle = (props: Props): React.ReactElement<'div'> => {
  const handleToggle = () => {
    if (!props.disabled) {
      props.onToggle(!props.enabled)
    }
  }

  const markerClass = `chart-toggle-marker chart-toggle-marker--${
    props.enabled ? 'enabled' : 'disabled'
  }`
  return (
    <div
      className={`chart-toggle ${cn({
        'chart-toggle--disabled': props.disabled,
      })}`}
      onClick={handleToggle}
    >
      <div
        className={markerClass}
        style={{
          backgroundColor: props.enabled ? props.color : '#fff',
          borderColor: props.color,
        }}
      />
      <div className="chart-toggle-label">{props.label}</div>
    </div>
  )
}

export default Toggle
